export const environment = {
  production: true,
  apiBaseUrl: 'https://test.api.sic.asst-spedalicivili.it/api',
  aadClientId: '37bdb299-9d80-490e-816e-e8240c9d25e9',
  aadTenantId: '92f46c1a-644a-40e4-83a0-c7b24680b25c',
  environment: 'test',
  agGridLicenseKey:
    'CompanyName=A.S.S.T. SPEDALI CIVILI DI BRESCIA,LicensedApplication=SIC BRESCIA ASSET MANAGER,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-035929,SupportServicesEnd=16_December_2023_[v2]_MTcwMjY4NDgwMDAwMA==54e6cf5864e196c007ebd517ef25a4af',
};
